import type {QueryFunctionContext, UseQueryOptions} from '@tanstack/react-query'
import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'

import {type SupportedLocales, useLocale} from '@/lib/locale/locale'
import type {StoresApiResponse} from '@/models/storeModel'
import {getStores} from '@/services/storeService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export function getStoresQueryKey(params: {locale: SupportedLocales}) {
  return ['stores', params.locale] as const
}

export function getStoresQueryOptions<TData = StoresApiResponse, TError = Error>(
  params: {locale: SupportedLocales},
  options?: Omit<UseQueryOptions<StoresApiResponse, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getStoresQueryKey(params),
    queryFn: async ({signal}: QueryFunctionContext) => {
      const res = await getStores({locale: params.locale, signal})
      return res
    },
    placeholderData: keepPreviousData,
    ...NO_REFETCH_OPTIONS,
    ...options,
  })
}

export function useStores() {
  const [locale] = useLocale()
  return useQuery(getStoresQueryOptions({locale}))
}
